module.exports = __webpack_public_path__ + "static/render_night_2K_sig-b9e953b973687ef833bd5433dbac266f.webp";